import React from 'react';

const HamburgerMenuButton = ({ onClick, title = 'Menu', className = 'icon-btn hamburger-menu-btn' }) => (
  <button
    type="button"
    className={className}
    onClick={onClick}
    title={title}
    aria-label={title}
  >
    <span className="hamburger-bar" aria-hidden="true" />
    <span className="hamburger-bar" aria-hidden="true" />
    <span className="hamburger-bar" aria-hidden="true" />
  </button>
);

export default HamburgerMenuButton;
